"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultPaymentMethodReducer = exports.bulkSavePaymentMethodReducer = exports.updatePaymentMethodReducer = exports.createPaymentMethodReducer = exports.fetchPaymentMethodReducer = exports.createDefaultPaymentMethodSlice = exports.bulkSavePaymentMethodSlice = exports.updatePaymentMethodSlice = exports.createPaymentMethodSlice = exports.fetchPaymentMethodSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const paymentMethodAction_1 = require("./paymentMethodAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: []
};
const createInitialState = {
    loading: false,
    error: null,
    data: []
};
const updateInitialState = {
    loading: false,
    error: null,
    data: []
};
const create_defaultInitialState = {
    loading: false,
    error: null,
    data: []
};
exports.fetchPaymentMethodSlice = (0, toolkit_1.createSlice)({
    name: "paymentMethod/list",
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(paymentMethodAction_1.fetch.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(paymentMethodAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(paymentMethodAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.createPaymentMethodSlice = (0, toolkit_1.createSlice)({
    name: "paymentMethod/create",
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(paymentMethodAction_1.create.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(paymentMethodAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(paymentMethodAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            console.log("in slice: ", action.error.message);
            state.data = [];
        });
    }
});
exports.updatePaymentMethodSlice = (0, toolkit_1.createSlice)({
    name: "paymentMethod/update",
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(paymentMethodAction_1.update.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(paymentMethodAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(paymentMethodAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.bulkSavePaymentMethodSlice = (0, toolkit_1.createSlice)({
    name: "paymentMethod/bulk_save",
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(paymentMethodAction_1.bulk_save.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(paymentMethodAction_1.bulk_save.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(paymentMethodAction_1.bulk_save.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.createDefaultPaymentMethodSlice = (0, toolkit_1.createSlice)({
    name: "paymentMethod/create_default",
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(paymentMethodAction_1.create_default.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(paymentMethodAction_1.create_default.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(paymentMethodAction_1.create_default.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.fetchPaymentMethodReducer = exports.fetchPaymentMethodSlice.reducer;
exports.createPaymentMethodReducer = exports.createPaymentMethodSlice.reducer;
exports.updatePaymentMethodReducer = exports.updatePaymentMethodSlice.reducer;
exports.bulkSavePaymentMethodReducer = exports.bulkSavePaymentMethodSlice.reducer;
exports.createDefaultPaymentMethodReducer = exports.createDefaultPaymentMethodSlice.reducer;
